import {
    setCookie,
    initializeMap,
    initMenuTrigger,
    initOpenInNewTab,
    //aosConfig,
    addScollClass,
    addParalax,
    addFancyboxFixForGallery,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews
} from './functions';

import wcQuantity from './wcQuantity';

import zoom from 'jquery-zoom';

import gsap from "gsap";


const mainApp = () => {



    // init menu trigger
    initMenuTrigger();

    // init open in new tab
    initOpenInNewTab();

    // init AOS animation config
    //aosConfig();

    // add scroll class to body  
    if (window.innerWidth > 768)
        addScollClass('100px');
    else
        addScollClass('0px');

    // add paralax to element
    addParalax('.paralax');



    //fix gallery id for slideshow
    addFancyboxFixForGallery('.blocks-gallery-grid');

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();




}

document.addEventListener("DOMContentLoaded", mainApp, false);


(function ($) {
    const mainAppWithJquery = () => {

        $('.mainContent__menu .menu-item-has-children').click(function () {

            if ($(this).hasClass('current-menu-ancestor-active')) {
                $('.mainContent__menu   .menu-item-has-children').removeClass('current-menu-ancestor-active');
            } else {
                $('.mainContent__menu   .menu-item-has-children').removeClass('current-menu-ancestor-active');
                $(this).addClass('current-menu-ancestor-active');
            }
        });

        $('.mainHeader__menuMobile .menu-item-has-children').click(function () {
            if ($(this).hasClass('current-menu-ancestor-active')) {
                $('.mainHeader__menuMobile  .menu-item-has-children').removeClass('current-menu-ancestor-active');
            } else {
                $('.mainHeader__menuMobile  .menu-item-has-children').removeClass('current-menu-ancestor-active');
                $(this).addClass('current-menu-ancestor-active');
            }
        });
        $('.menu-item a[href="#"]').each(function () {
            $(this).removeAttr('href');
        });

        /* $('.menu-item a[href="#"]').click(function (e) {
             e.preventDefault;
             return false;
         });*/



        // add to cart
        $(document.body).on('added_to_cart', function (e, obj, cart_hash, $button) {
            console.log($button);
            $('.mainHeader__cartTotal').html(obj['cartTotal']);
            $('.miniCartContent').addClass('show');
            window.setTimeout(function () {
                $('.miniCartContent').removeClass('show');
            }, 3000);
        });

        //remove from cart
        $(document.body).on('removed_from_cart', (e, obj) => {
            $('.miniCartContent').html(obj['div.widget_shopping_cart_content']);
            $('.mainHeader__cartTotal').html(obj['cartTotal']);
        });
        // single page add to cart
        $(document).on('click', '.single_add_to_cart_button', function (e) {
            e.preventDefault();

            var $thisbutton = $(this),
                $form = $thisbutton.closest('form.cart'),
                id = $thisbutton.val(),
                product_qty = $form.find('input[name=quantity]').val() || 1,
                product_id = $form.find('input[name=product_id]').val() || id,
                variation_id = $form.find('input[name=variation_id]').val() || 0;

            var data = {
                action: 'woocommerce_ajax_add_to_cart',
                product_id: product_id,
                product_sku: '',
                quantity: product_qty,
                variation_id: variation_id,
            };

            $(document.body).trigger('adding_to_cart', [$thisbutton, data]);

            $.ajax({
                type: 'post',
                url: wc_add_to_cart_params.ajax_url,
                data: data,
                beforeSend: function (response) {
                    $thisbutton.removeClass('added').addClass('loading');
                },
                complete: function (response) {
                    $thisbutton.addClass('added').removeClass('loading');
                },
                success: function (response) {
                    if (response.error && response.product_url) {
                        window.location = response.product_url;
                        return;
                    } else {
                        $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                    }
                },
            });

            return false;
        });




        //add quantity buttons
        const quantityWc = new wcQuantity();

        $(document.body).on('updated_wc_div', () => { quantityWc.init() });

        quantityWc.init();

        const gPriceContent = $('.productDetail  .price').html();

        function detailVariantPrice() {
            if ($('.woocommerce-variation.single_variation .woocommerce-variation-price').html() != '') {
                const pVal = $('.woocommerce-variation.single_variation').html();
                if (pVal != '') {
                    $('.productDetail .price').html(pVal);
                } else {
                    $('.productDetail .price').html(gPriceContent);
                }
            }
        }

        $(document.body).on('woocommerce_variation_has_changed', (e, obj) => {
            detailVariantPrice();

        });
        window.setTimeout(function () {
            detailVariantPrice();
        }, 1000);
        //   detailVariantPrice();



        $('.pFilter__cleanButton').click(function () {
            var form = $(this).parents('form').find('input').each(function () {
                if ($(this).is(':checked')) {
                    $(this).removeAttr('checked');
                }
                if ($(this).attr('type') == 'number') {
                    $(this).attr('value', '');
                }
            });
            $('.pFilter__filterButton').click();
        });


        function wc_load_all_orders(id, trigger) {


            jQuery.ajax({
                type: "POST",
                url: ajaxParams.ajaxurl,
                data: { action: 'gGetProductDetail', post_id: id },
                success: function (data) {
                    trigger.removeClass('loading');
                    $.fancybox.open(data, {
                        baseClass: "quick-view-container",
                        infobar: false,
                        buttons: false,
                        thumbs: false,
                        margin: 0,
                        touch: {
                            vertical: false
                        },
                        animationEffect: false,
                        transitionEffect: "slide",
                        transitionDuration: 500,
                        afterShow: function (instance) {

                            quantityWc.init();
                            $('.quickViewImage a').removeAttr('href');
                        }
                    });


                }
            });
            return false;
        }


        $('.productPreview').click(function () {
            let pId = $(this).data('id');
            $(this).addClass('loading');
            wc_load_all_orders(pId, $(this));
        });

        //rotator and sliders
        if ($('.rotatorTop').length > 0) {
            $('.rotatorTop').slick({
                infinite: true,
                arrows: false,
                dots: true,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                autoplaySpeed: 5000,
                fade: true,
                cssEase: 'linear'
            });
            var currentRotSlide = 0;
            $('.rotatorTop').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                currentRotSlide = currentSlide;
                $('.rotatorTop .rotator__slide:nth-child(' + (currentSlide + 1) + ')').addClass('slick-out');
            });
            $('.rotatorTop').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                $('.rotatorTop .rotator__slide:nth-child(' + (currentRotSlide + 1) + ')').removeClass('slick-out');
            });
        }




        if ($('.productSlider').length > 0) {
            $('.productSlider').slick({
                infinite: true,
                arrows: true,
                dots: false,
                autoplay: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                speed: 500,
                autoplaySpeed: 10000,
                responsive: [
                    {
                        breakpoint: 1201,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });

        }
        if ($('.producentSlider').length > 0) {
            $('.producentSlider').slick({
                infinite: true,
                arrows: true,
                dots: false,
                autoplay: true,
                // slidesToShow: 4,
                // slidesToScroll: 1,
                slidesToShow: 3,
                centerMode: true,
                variableWidth: true,
                speed: 500,
                autoplaySpeed: 10000,
            });

        }




        $('.woocommerce-product-gallery--with-images .woocommerce-product-gallery__sliderMain').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            fade: true,
            asNavFor: '.woocommerce-product-gallery__sliderThumbs'
        });
        $('.woocommerce-product-gallery--with-images .woocommerce-product-gallery__sliderMain a').attr('data-fancybox', 'productGal')
        $('.woocommerce-product-gallery--with-images .woocommerce-product-gallery__sliderMain a').zoom();

        $('.woocommerce-product-gallery--with-images .woocommerce-product-gallery__sliderMain .slick-slide').mouseover(function () {

            if ($(this).hasClass('slick-active')) {

                $(this).find('img:first-child').addClass('hide');
            }
        }).mouseout(function () {

            $(this).find('img:first-child').removeClass('hide');
        });


        $('.woocommerce-product-gallery--with-images .woocommerce-product-gallery__sliderThumbs').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            asNavFor: '.woocommerce-product-gallery__sliderMain',
            dots: false,
            arrows: true,
            centerMode: false,
            focusOnSelect: true,
            vertical: true,
            responsive: [
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        vertical: false,
                    }
                }
            ]
        });
        $('.woocommerce-product-gallery--with-images .woocommerce-product-gallery__sliderThumbs a').click(function (e) {
            e.preventDefault();
        });


        let vIdInput = $('input.variation_id');


        if (vIdInput.length > 0) {
            const varTab = JSON.parse($('.variations_form.cart').attr('data-product_variations'));
            vIdInput.on('change', function (e) {
                const v = vIdInput.val();
                if (v != 0) {
                    for (let i = 0; i < varTab.length; i++) {
                        let variation = varTab[i];
                        if (v == variation.variation_id) {
                            $('.woocommerce-product-gallery__sliderThumbs .slick-slide:first').find('a').attr('href', variation.image.url)
                                .find('img').attr('src', variation.image.gallery_thumbnail_src).attr('data-src', '').attr('srcset', '');
                            let mainImg = $('.woocommerce-product-gallery__sliderMain .slick-slide:first');
                            let mainImgA = $('.woocommerce-product-gallery__sliderMain .slick-slide:first a');
                            let mainImgImg = $('.woocommerce-product-gallery__sliderMain .slick-slide:first img');
                            mainImg.attr('data-thumb', variation.image.gallery_thumbnail_src);
                            mainImgA.attr('href', variation.image.url);
                            mainImgImg.attr('src', variation.image.url).attr('data-src', '')
                                .attr('srcset', '')
                                .attr('data-large_image', variation.image.url);
                            mainImgA.trigger('zoom.destroy');
                            mainImgA.zoom({
                                url: variation.image.url
                            });
                            $('.woocommerce-product-gallery__sliderThumbs .slick-slide:first').find('a').click();
                            break;
                        }
                    }
                }
            });

            vIdInput.change();
        }

        window.setTimeout(function () {
            var addCheckoutLabel0 = $('#getInvoice_field.form-row');
            if (addCheckoutLabel0.length > 0) {


                var html = '<label class="woocommerce-form__label woocommerce-form__label-for-checkbox checkbox">'
                    + '<input type="checkbox" class="input-checkbox " name="getInvoice" id="getInvoice" value="TAK">'
                    + '<span class="woocommerce-terms-and-conditions-checkbox-text">' + addCheckoutLabel0.find('label').text() + '</span>'
                    + '</label>';
                addCheckoutLabel0.html('');
                addCheckoutLabel0.append(html);

                var addCheckoutLabel1 = $('#getInvoiceEmail_field.form-row');
                if (addCheckoutLabel1.length > 0) {
                    var html = '<label class="woocommerce-form__label woocommerce-form__label-for-checkbox checkbox">'
                        + '<input type="checkbox" class="input-checkbox " name="getInvoiceEmail" id="getInvoiceEmail" value="TAK">'
                        + '<span class="woocommerce-terms-and-conditions-checkbox-text">' + addCheckoutLabel1.find('label').text() + '</span>'
                        + '</label>';
                    addCheckoutLabel1.html('');
                    addCheckoutLabel1.append(html);

                }

            }


        }, 100);



        //fancybox
        $(".blocks-gallery-item a, .fancybox, .wp-block-image a").fancybox({
            'loop': true,
            'margin': [44, 0],
            'gutter': 50,
            'keyboard': true,
            'arrows': true,
            'infobar': false,
            'toolbar': true,
            'buttons': ["slideShow", "fullScreen", "close"],
            'idleTime': 4,
            'protect': false,
            'modal': false,
            'animationEffect': "fade",
            'animationDuration': 600,
            'transitionEffect': "fade",
            'transitionDuration': 800,
        });



    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);



